import { Box, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from 'react-i18next';

import { DATA_HOOKS } from '../../../dataHooks';
import { SparklesIcon } from '../../../icons/SparklesIcon';

import css from './index.module.scss';

interface CopilotButtonProps {
  onClick: () => void;
}

export const CopilotButton = ({ onClick }: CopilotButtonProps) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      data-hook={DATA_HOOKS.COPILOT_BUTTON}
      className={css.copilotButton}

    >
      <Tooltip content={t('article-page.copilot.tooltip')} enterDelay={300} size="small" moveBy={{ y: 12 }}>
        <Box align="center" verticalAlign="middle" gap="12px">
          <SparklesIcon />
          <Text size="small">{t('article-page.copilot')}</Text>
        </Box>
      </Tooltip>
    </div>
  );
};
